module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/icon_plan_delax-4884d70e41e3936c2571913c76a5678b.png";